import {CheckboxControl} from '../../index.styled';

interface Props {
	disabled?: boolean;
	onChange: (value: boolean) => void;
	value: boolean;
}

export function ShowAllStudentsControl(props: Props) {
	const {disabled, onChange, value} = props;

	return <CheckboxControl checked={value} onCheckedChange={(value) => onChange(Boolean(value))} label='Show all' disabled={disabled}/>;
}
